const api = {
	settleBills: '/mallSettlement/settleBills', // 确认结算账单
	listBills: '/mallSettlement/listBills', // 查询商户账单列表
	listBillDates: '/mallSettlement/listBillDates', // 查询结算周期列表
	listAllCouponBillMerchants: '/mallSettlement/listAllCouponBillMerchants',  // 查询所有结算商户列表
	downloadBillDetail: '/mallSettlement/downloadBillDetail', // 下载结算明细
	getMallBillDetail: '/mallSettlement/getBillDetail' //查询商城结算明细
};

const routes = {
	'/mall-bill': '对账单',
	'/mall-bill/detail': '对账明细'
};

export { api, routes };
